export default __webpack_public_path__ + "static/insta-hotels-5-9d68f17f96d5a5b0c483fbb30a64c154.jpg";